import {
  getDimensionPalletSpaces,
  shouldShowPalletSpaces,
} from '@b-stock/fe-core/bstock-next/helpers'
import type { LeanGroup } from '@b-stock/fe-core/bstock-next/queries'

export const calculateShipmentDetails = (groups: LeanGroup[]) => {
  let totalWeightInGrams = 0
  let numberOfUnits = 0
  let showPalletSpaces = false
  let totalPalletSpaces = 0
  for (const group of groups) {
    showPalletSpaces ||= shouldShowPalletSpaces(group)
    if (group.dimensions) {
      for (const dim of group.dimensions) {
        numberOfUnits += dim.count ?? 1
        totalPalletSpaces += getDimensionPalletSpaces(group.type, dim) ?? 0
        totalWeightInGrams += dim.weight?.gValue ?? 0
      }
    }
  }

  return {
    numberOfUnits,
    totalWeightInGrams,
    showPalletSpaces,
    totalPalletSpaces,
  }
}
